import { z } from 'zod';
import {
    companyDetailsQuerySchema,
    CompanyDetailsQueryValues,
} from '../../../companyDetail/components/companyDetailsQuerySchema';
import { PaymentsTabActiveSegment } from './types';

const activePaymentSegmentQuerySchema = z.object({
    activeSegment: z.nativeEnum(PaymentsTabActiveSegment).default(PaymentsTabActiveSegment.Overview),
});

type ActivePaymentSegmentQueryValues = z.infer<typeof activePaymentSegmentQuerySchema>;

export const paymentSegmentsQuerySchema = z.union([companyDetailsQuerySchema, activePaymentSegmentQuerySchema]);

export const isCompanyDetailsQueryValues = (
    values: Partial<CompanyDetailsQueryValues> | Partial<ActivePaymentSegmentQueryValues> | undefined,
    isCompany: boolean
): values is CompanyDetailsQueryValues => isCompany && !!(values && 'tab' in values);
